/**
 * FusionMSI product naming — single source for display vs spoken (TTS) forms.
 * Display: FusionMSI · Spoken: Fusion M S I (MSI as acronym).
 * Platform-wide brand constants live in `src/config/platformBranding.js`.
 */

import { PLATFORM_NAME, PLATFORM_NAME_LONG } from "config/platformBranding";

export const PRODUCT_NAME = PLATFORM_NAME;
export const PRODUCT_NAME_SPOKEN = "Fusion M S I";
export const PRODUCT_NAME_LONG = PLATFORM_NAME_LONG;
/** User-facing tagline under the FusionMSI wordmark and on short product labels. */
export const PRODUCT_TAGLINE = "Medical SuperIntelligence™ + Continuity of Care";

/** Replace display product name with spoken form for TTS strings. */
export function productNameForSpeech(text) {
  if (!text) return text;
  return String(text).replace(/FusionMSI/g, PRODUCT_NAME_SPOKEN);
}
